import {ICellRendererParams} from "@ag-grid-community/core";
import {jobStatusResolver} from "../../../utils/stops/JobStatusResolver";
import JobStatusBadge from "../JobStatusBadge";

const JobStatusCellRenderer = (props: ICellRendererParams<any, string>) => {
  return <JobStatusBadge status={jobStatusResolver(props.value)} />;
};

export default JobStatusCellRenderer;
